export default __webpack_public_path__ + "static/media/image 12.e90eb281.png";